// extracted by mini-css-extract-plugin
module.exports = {"addButton":"StudentsTable_addButton__3jqhl","searchField":"StudentsTable_searchField__3FNX9"};